import * as React from 'react';
import { SVGProps } from 'react';

const IconDownloadSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M22 22v-2H2v2h20zM18.59 8.59 20 10l-8 8-8-8 1.41-1.41L11 14.17V2h2v12.17l5.59-5.58z" />
  </svg>
);
export default IconDownloadSizeM;
